import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class InventoryStatusService {
    constructor(private http: AuthHttp) { }

    getInventoryStatusesWithDescription() {
        return this.http.get(AppSettings.apiEndpoint + "InventoryStatus/GetInventoryStatusesWithDescription")
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/inventory-status.service.ts